import {Box, Stack} from "@mui/material"
import BlendedPresenceRateCard from 'src/components/competitive-intelligence/components/BlendedPresenceRateCard';
import ByPressureCard, { PressurePoolDatum } from 'src/components/competitive-intelligence/components/ByPressureCard';
import TopCompetitorsCard, { TopCompetitorStat } from 'src/components/competitive-intelligence/components/TopCompetitorsCard';

interface WeeklyDataPoint {
  week_start: string;
  solo_bidder: number;
  top_ad_position: number;
  organic_only: number;
  compet_only: number;
}

interface CardBarProps {
  blendedPresenceTitle: string;
  blendedPresenceContent?: string;
  blendedPresenceTopMetric?: string;
  blendedPresenceWeeklySeries?: WeeklyDataPoint[];
  pressureTitle: string;
  pressureContent?: string;
  pressurePools?: PressurePoolDatum[];
  topCompetitorsTitle: string;
  topCompetitorsData?: TopCompetitorStat[];
  dateRange?: string;
  loading?: boolean;
}

export function CardBar({
  blendedPresenceTitle,
  blendedPresenceContent,
  blendedPresenceTopMetric,
  blendedPresenceWeeklySeries,
  pressureTitle,
  pressureContent,
  pressurePools,
  topCompetitorsTitle,
  topCompetitorsData,
  dateRange = "12 weeks",
  loading = false,
}: CardBarProps) {

    return (
      <Box sx={{width: '100%' }}>
            <Stack direction="row" gap="20px">
              <BlendedPresenceRateCard 
                title={blendedPresenceTitle} 
                mainContentTitle={blendedPresenceContent} 
                dateRange={dateRange} 
                topMetric={blendedPresenceTopMetric}
                weeklySeries={blendedPresenceWeeklySeries}
                loading={loading}
              />
              <ByPressureCard 
                title={pressureTitle} 
                content={pressureContent} 
                dateRange={dateRange} 
                pools={pressurePools}
                loading={loading}
              />
              <TopCompetitorsCard 
                title={topCompetitorsTitle} 
                dateRange={dateRange} 
                competitors={topCompetitorsData}
                loading={loading}
              />
            </Stack>
      </Box>
    );
  }


